import { ApiError } from "@/lib/api-error"

import { reportHandledError } from "./app-insights-global"

/**
 * Central TanStack Query error → telemetry funnel (M21). Before this existed,
 * API failures only reached App Insights if they crashed a render into an error
 * boundary — per-site `onError` toasts swallowed them. The QueryCache and
 * MutationCache route every failure here exactly once (reportHandledError
 * dedupes by error object, so per-site toasts stay pure UX).
 *
 * Deliberately skipped, because they are expected outcomes, not defects:
 *  - 401: session expiry — the auth gate handles re-signin.
 *  - 402: the free-tier scale gate — renders the upgrade prompt.
 *  - offline: the UI has explicit offline handling; reporting fetch failures
 *    from a train tunnel is pure noise.
 */
export function reportCacheError(
  error: unknown,
  kind: "query" | "mutation",
  key: string
): void {
  if (
    error instanceof ApiError &&
    (error.status === 401 || error.status === 402)
  )
    return
  if (typeof navigator !== "undefined" && navigator.onLine === false) return

  reportHandledError(error, {
    source: `tanstack_${kind}`,
    key,
    status: error instanceof ApiError ? String(error.status) : undefined,
  })
}
